/**
 * streamlines add a dynamic value to background-color.
 * @param {object} param0
 * @param {string} param0.$backgroundColor
 * @returns {string}
 */
const dynBackgroundColor = ({ $backgroundColor }) => {
  if ($backgroundColor === undefined) return "";
  return `background-color: ${$backgroundColor};`;
};

export default dynBackgroundColor;
